import { styled } from 'styled-components';

export const LoaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  animation: fadeIn ${({ theme }) => theme.animation.duration.default}
    ${({ theme }) => theme.animation.easing.moving};
  height: ${({ $height }) => $height};

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  div[role='progressbar'] {
    border-color: ${({ theme }) => theme.colours.ink.primary.main};
    border-top-color: transparent !important;
  }
`;
LoaderWrapper.displayName = 'LoaderWrapper';

export const LoaderLabel = styled.div`
  margin-top: ${({ theme }) => theme.sizing.small};
  ${({ theme }) => theme.typography.bodyRegular}
  color: ${({ theme }) => theme.colours.ink.primary.main};
`;
LoaderLabel.displayName = 'LoaderLabel';
